import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IndicatorService } from './indicators.service';

@Component({
    selector: 'app-indicators',
    templateUrl: './indicators.component.html',
    styleUrls: ['./indicators.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class IndicatorsComponent implements OnInit {

    private onDestroy: Subject<void> = new Subject<void>();

    ufToday: any;
    dolarToday: any;
    euroToday: any;
    ipcToday: any;
    utmToday: any;

    constructor( 
        private indicatorService: IndicatorService,
        private msg: NzMessageService,
        private router: Router
    ) {}

    
    ngOnInit(){
        this.getIndicators();     
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.complete();
    }

    getIndicators(){
        this.indicatorService.getIndicator()
        .pipe(takeUntil(this.onDestroy))
        .subscribe(data => {
            this.ufToday = data['uf'];
            this.ipcToday = data['ipc'];
            this.dolarToday = data['dollar'];
            this.euroToday = data['euro'];
            this.utmToday = data['utm'];
            console.log(data)
        },            
        err => {
            if (err.status === 401){
                this.msg.error('Su sesión a expirado.');
                this.router.navigate(['/login']);
            }
            console.error('Error to get indicators');
            console.error(err);
        });
            
    }
}   